export default __webpack_public_path__ + "static/media/export-2.a0fc45bd.png";